import { ThunkDispatch } from '@reduxjs/toolkit';
import { updateDeviceTokenMessage } from '@slice/user.slice';
import { message } from 'antd';
import AuthServiceApi from 'apis/api/Auth';
import { useExtendDeviceToken } from 'apis/queries';
import { RootState } from 'app/store';
import { getMessagingToken } from '../../../firebase';
import { INTERVAL_DTOKEN } from 'global/Global';
import { useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

export function useFcmToken() {
  const { t } = useTranslation();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const deviceTokenMessage = useSelector((s: RootState) => s.user.deviceTokenMessage);

  const refInterval = useRef<any>(null);
  const refRetry = useRef<any>(null);
  const refAlive = useRef(true);

  const [, extendToken]: any = useExtendDeviceToken({
    onSuccess: (r: any) => console.log('extend device token ok', r),
    onError: (e: any) => console.log('extend device token err', e)
  });

  const setUpTokenMessage = useCallback(
    async (retryCount = 0) => {
      const tokenDevice = await getMessagingToken();
      if (!refAlive.current) return;

      if (!tokenDevice) {
        if (retryCount < 3) {
          refRetry.current = setTimeout(() => setUpTokenMessage(retryCount + 1), 500);
        } else {
          console.warn('Quá số lần thử lấy token');
        }
        return;
      }

      const bodyAPI = { deviceToken: tokenDevice, platform: 'web', version: '', deviceId: '' };
      try {
        const res = await AuthServiceApi.UpdateDeviceToken(bodyAPI);
        if (!res.data.error) {
          dispatch(updateDeviceTokenMessage(bodyAPI));
          message.success(t('Notification.SetUpFCMOk'));
        }
      } catch (error) {
        console.log('send tokenDevice err', tokenDevice);
      }
    },
    [dispatch, t]
  );

  // 1. Lúc mount: kiểm tra quyền thông báo, có quyền mà chưa có token thì lấy token
  useEffect(() => {
    refAlive.current = true;

    if (Notification.permission === 'granted') {
      if (!deviceTokenMessage) setUpTokenMessage();
    } else {
      // 'default' (chưa hỏi) hiện chưa tự xin quyền, giữ hành vi cũ
      dispatch(updateDeviceTokenMessage(null));
      console.warn('Thông báo đã bị chặn bởi trình duyệt.');
    }

    return () => {
      refAlive.current = false;
      clearTimeout(refRetry.current);
    };
  }, []);

  // 2. Có token thì gia hạn ngay và gia hạn định kỳ
  useEffect(() => {
    if (!deviceTokenMessage) return;

    extendToken(deviceTokenMessage);
    refInterval.current = setInterval(() => extendToken(deviceTokenMessage), INTERVAL_DTOKEN);

    return () => {
      clearInterval(refInterval.current);
      refInterval.current = null;
    };
  }, [deviceTokenMessage]);
}
